import { useState, useEffect } from 'react';
import { IDriverUser } from '../../types/type';
import { AutoparkService, IAutopark, IAutoparkCar } from '../../services/autopark.service';
import './driverAutoparks.css';

// Расширенный тип автомобиля с именем автопарка
interface ICarWithAutoparkName extends IAutoparkCar {
  autoparkName: string;
}

function DriverAutoparks({ driver }: { driver: IDriverUser }) {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [autoparks, setAutoparks] = useState<IAutopark[]>([]);

  useEffect(() => {
    const fetchAutoparks = async () => {
      try {
        setLoading(true);
        setError(null);
        const data = await AutoparkService.getDriverAutoparks(driver.id);
        setAutoparks(data || []);
      } catch (error: any) {
        console.error('Ошибка при загрузке автопарков:', error);
        setError(error.message || 'Не удалось загрузить автопарки');
        setAutoparks([]);
      } finally {
        setLoading(false);
      }
    };

    fetchAutoparks();
  }, [driver.id]);

  // Собираем все автомобили из всех автопарков
  const allCars: ICarWithAutoparkName[] = (autoparks || []).flatMap((autopark) =>
    (autopark.cars || []).map((car) => ({
      ...car,
      autoparkName: autopark.tradeName || 'Неизвестный автопарк',
    })),
  );

  return (
    <div className="driver-autoparks">
      <h2 className="driver-autoparks__title">Автопарки водителя</h2>

      {loading ? (
        <div className="driver-autoparks__loading">Загрузка автопарков...</div>
      ) : error ? (
        <div className="driver-autoparks__error">{error}</div>
      ) : allCars.length === 0 ? (
        <div className="driver-autoparks__empty">Нет доступных автопарков</div>
      ) : (
        <div className="driver-autoparks__content">
          <table className="driver-autoparks__table">
            <thead>
              <tr>
                <th className="column">Гос. номер</th>
                <th className="column">Марка</th>
                <th className="column">Модель</th>
                <th className="column">Автопарк</th>
              </tr>
            </thead>
            <tbody>
              {allCars.map((car) => (
                <tr key={car.id}>
                  <td className="column">{car.number}</td>
                  <td className="column">{car.mark}</td>
                  <td className="column">{car.model}</td>
                  <td className="column">{car.autoparkName}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}

export default DriverAutoparks;
